import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';


import { translate } from 'services/i18nService';
import FirebaseStore from 'stores/FirebaseStore';
import BroadcasterPauseState from 'components/BroadcasterPauseState/BroadcasterPauseState';
import Button from 'components/Button/Button';

import styles from './StreamHidden.css';


function StreamHidden(props) {
  const { isBroadcaster, onClick } = props;
  const { broadcastPaused } = FirebaseStore;

  if (broadcastPaused && isBroadcaster) {
    return <BroadcasterPauseState />;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.text}>{translate('v2broadcast.video.disabled')}</div>
      <Button label={translate('v2broadcast.enable.video')} onClick={onClick} />
    </div>
  );
}

StreamHidden.propTypes = {
  onClick: PropTypes.func.isRequired,
  isBroadcaster: PropTypes.bool,
};

StreamHidden.defaultProps = { isBroadcaster: false };

export default observer(StreamHidden);
